import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  THandleFinixWebhooksRequestSchema,
  THandleFinixWebhooksResponseSchema,
} from "./handleFinixWebhooks.schema";

export const handleFinixWebhooks = (axios: IAxiosInstance) => {
  return async (body: THandleFinixWebhooksRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<THandleFinixWebhooksResponseSchema>
    >(`/api/business-cards/webhooks`, body);

    return response.data;
  };
};
